// extracted by mini-css-extract-plugin
module.exports = {"main":"ErrorScreen-module__main--1DNs5"};